export const CloseSmallIcon = () => (
  <svg aria-hidden="true" fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
  </svg>
)
